import { cn } from '@/lib/utils';

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Carregando"
      className={cn(
        'size-7 animate-spin rounded-full border-[3px] border-primary-tint border-t-primary',
        className,
      )}
    />
  );
}

/** Spinner centralizado para estados de carregamento de página. */
export function PageLoading() {
  return (
    <div className="flex justify-center py-20">
      <Spinner />
    </div>
  );
}
